/**
 * Helper function to calculate point coordinates with scaling and offset applied
 * Used for converting Konva shape points to SVG coordinates
 *
 * @param point - The original point value
 * @param scale - The scale factor for this axis
 * @param offset - The offset for this axis (shape position)
 * @returns The scaled and offset coordinate
 */
export function getScaledPointCoord(point: number, scale: number, offset: number): number {
  return (point * scale + offset) / scale;
}

/**
 * Helper function to calculate point coordinates with scaling and offset applied
 * Used for converting SVG coordinates back to Konva shape points
 *
 * @param point - The scaled point value from SVG
 * @param scale - The scale factor for this axis
 * @param offset - The offset for this axis (shape position)
 * @returns The original coordinate without scaling
 */
export function getOriginalPointCoord(point: number, scale: number, offset: number): number {
  return (point * scale - offset) / scale;
}
